import { render, staticRenderFns } from "./PuzzleVerification.vue?vue&type=template&id=79a69c4e&scoped=true&"
import script from "./PuzzleVerification.vue?vue&type=script&lang=js&"
export * from "./PuzzleVerification.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleVerification.vue?vue&type=style&index=0&id=79a69c4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a69c4e",
  null
  
)

export default component.exports